export const ADDRESS_FORM_NEW_ID = 'NEW';

/** Which address form the profile address pages have open: an existing address id, a new one, or none. */
export type ShowedAddressForm = number | typeof ADDRESS_FORM_NEW_ID | null;
